<div *ngIf="showActionsMenu">
  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="liabilityMenuDisabled">
    <app-icon name="more_vert"></app-icon>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <ng-container *ngIf="showAddToCart">
      <button [appApiCallLoading]="initPayment" mat-menu-item [disabled]="liabilityMenuDisabled">
        <app-icon name="add_shopping_cart" color="rgba(0, 0, 0, 0.7)"></app-icon>
        Dodaj do koszyka
      </button>
    </ng-container>

    <button
      *ngIf="showRedirectToCart"
      mat-menu-item
      [routerLink]="['/liabilities', 'pay', liability.uncompletedPaymentId]"
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="shopping_cart" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Przejdź do koszyka
    </button>

    <button *ngIf="showEdit" [appApiCallLoading]="edit" mat-menu-item [disabled]="liabilityMenuDisabled">
      <app-icon name="edit" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Edytuj wydatek
    </button>

    <ng-container *ngIf="showMarkAsPaid">
      <button [appApiCallLoading]="markAsPaid" mat-menu-item [disabled]="liabilityMenuDisabled">
        <app-icon name="done" color="rgba(0, 0, 0, 0.7)"></app-icon>
        Oznacz jako rozliczony
      </button>
    </ng-container>

    <ng-container *ngIf="showMarkAsNotPaid">
      <button [appApiCallLoading]="markAsNotPaid" mat-menu-item [disabled]="liabilityMenuDisabled">
        <app-icon name="money_off" color="rgba(0, 0, 0, 0.7)"></app-icon>
        Oznacz jako nierozliczony
      </button>
    </ng-container>

    <button *ngIf="showRemove" [appApiCallLoading]="hide" mat-menu-item [disabled]="liabilityMenuDisabled">
      <app-icon name="delete" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Usuń
    </button>

    <ng-container *ngIf="showRemoveFromCart">
      <button [appApiCallLoading]="cancelPayment" mat-menu-item [disabled]="liabilityMenuDisabled">
        <app-icon name="remove_shopping_cart" color="rgba(0, 0, 0, 0.7)"></app-icon>
        Usuń z koszyka
      </button>
    </ng-container>

    <button
      *ngIf="showEnableAutoPayment && this.appConfig.config.payment.autoPayment.enabled"
      [appApiCallLoading]="enableAutoPayment"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="alarm_on" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Ustaw autopłatność
    </button>

    <button
      *ngIf="showCreateAutoPayment && this.appConfig.config.payment.autoPayment.enabled"
      [appApiCallLoading]="createAutoPayment"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="alarm_on" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Ustaw autopłatność
    </button>

    <button
      *ngIf="showCancelAutoPayment"
      [appApiCallLoading]="disableAutoPayment"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="alarm_off" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Anuluj autopłatność
    </button>

    <button
      *ngIf="showDelegate"
      [appApiCallLoading]="delegateLiability"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="forward" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Przekaż do opłacenia
    </button>

    <button
      *ngIf="showDeleteDelegation"
      [appApiCallLoading]="deleteLiabilityDelegation"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="clear" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Wyłącz przekazywanie
    </button>

    <button
      *ngIf="canBeReminded"
      [appApiCallLoading]="remindAboutPayment"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="add_alert" color="rgba(0, 0, 0, 0.7)" class="mr-8"></app-icon>
      Wyślij przypomnienie
    </button>

    <button *ngIf="showDownloadPdf" [appApiCallLoading]="downloadPdf" mat-menu-item [disabled]="liabilityMenuDisabled">
      <app-icon name="save_alt" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Pobierz dokument
    </button>

    <button
      *ngIf="false && !!liability.btApiAccountId"
      (click)="reportBtApiIssue()"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="bug_report" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Zgłoś problem
    </button>

    <button
      *ngIf="showDetails"
      [routerLink]="['/liabilities', liability.id]"
      mat-menu-item
      [disabled]="liabilityMenuDisabled"
    >
      <app-icon name="description" color="rgba(0, 0, 0, 0.7)"></app-icon>
      Zobacz szczegóły
    </button>
  </mat-menu>
</div>

<a hidden #downloadPdfLink target="_blank"></a>
